import styled from 'styled-components';
import ReactEcharts from 'echarts-for-react';
import {observer} from 'mobx-react-lite';
import {SkeletonHorizontalLoaderGray} from '@/components/common-components/components';
import {ColumnsType} from 'antd/lib/table';
import {getProgressColor} from '@/utils/colors';
import {formatNumber, formatLargeNumber} from '@/utils/number';
import {Collapse, Tooltip} from 'antd';
import {graphic} from 'echarts';
import {Badge} from 'antd';
import numeral from 'numeral';
import {renderToString} from 'react-dom/server';
import moment from 'moment';
import {EChartOption} from 'echarts';
import {useStore} from '@/store/root-store';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCaretDown, faCaretRight} from '@fortawesome/pro-solid-svg-icons';
import {useState, useEffect} from 'react';
import {SkeletonRingLoader} from '@/components/common-components';
import {truncate} from '@/utils/string';
import {faCircleInfo} from '@fortawesome/pro-regular-svg-icons';
import {EmptyStateKeDetail} from './emptyStateKe';
import {getDomain, isPublicKeywordResearcherV2, removeProtocolAndPrefix} from '@/utils/url';
import {getSingleUrlParam} from '@/utils/url';
import {UrlDropdown} from './commonUrlDropdown';
import {ChartOverlayBanner} from '../../ke-common-components/chartOverlayBanner';
import {useRouter} from 'next/router';
import {TableStyled} from '../../../home-page-main/components/table-styled';
import {Button} from '@/components/common-components';
import {linkgraphDomains} from '@/utils/router';
import {NextImg} from '@/utils/nextImg';

export const KeywordCompetition = observer(() => {
  const router = useRouter();
  const keywordSerp = router.query?.keyword;
  const {
    keywordResearcherV2: {
      keywordDetails: {
        exportSerpTable,
        exportingSerpOverview,
        getSerpOverviewDetails,
        getKeywordDetailsData,
        getOrganicPaidHistoryData,
        loadingOrganicPaidHistoryDetails,
        loadingSerpOverviewDetails,
        // getKeywordDetailList,
        // keSelectedKeyword,
      },
    },
  } = useStore('');
  const {settings: {customer: {setAuthModal}}} = useStore('');
  const cardsData = getOrganicPaidHistoryData?.organicRankings?.serpAnalysis;
  const [selectedDuration, setSelectedDuration] = useState('All time');
  const [loadAllRecord, setLoadAllRecord] = useState(false);
  const [checkedList, setCheckedList] = useState([]);
  const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 0);
  const countryCode = getSingleUrlParam('countryCode') || getKeywordDetailsData?.countryCode;
  const currentDomain = getDomain(window.location.hostname);
  const isWhiteLabelDomain = !linkgraphDomains.includes(currentDomain);
  const getDataByDate = (diff, dataList) => {
    const startDate = new Date(moment().startOf('month').subtract(diff, 'months').format('YYYY-MM-DD'));
    const endDate = new Date(moment().startOf('month').format('YYYY-MM-DD'));
    const resultProductData = dataList?.filter(a => {
      const date = new Date(a?.date);
      return (date >= startDate && date <= endDate);
    });
    return resultProductData;
  };
  const getChartData = data => {
    switch (selectedDuration) {
      case '3m':
        return getDataByDate(3, data);
      case '6m':
        return getDataByDate(6, data);
      case '1y':
        return getDataByDate(12, data);
      case 'All time':
        return data?.slice();
      default:
        return [];
    }
  };
  const chartData = getChartData(getOrganicPaidHistoryData?.organicRankings?.graph);
  const getArrangedData = (key, data) => {
    switch (key) {
      case 'answer_box':
        return data?.answers?.map(item => item?.answer);
      case 'people_also_ask':
        return data?.map((item, idx) => {
          return {
            id: idx + 1,
            title: item?.question,
            subTitle: item?.answer,
            DisplayLink: item?.source?.displayedLink,
            link: item?.source?.link,
          };
        });
      case 'knowledge_graph':
        return data?.images?.map(item => {
          return {
            DisplayLink: item?.slice(0, 50)+'...',
            link: item,
          };
        });
      case 'videos':
        return data?.map(item => {
          return {
            title: item?.title,
            subTitle: item?.source,
            DisplayLink: item?.link,
            link: item?.link,
          };
        });
      case 'ads':
        return data?.map((item, idx) => {
          return {
            id: idx + 1,
            title: item?.title,
            subTitle: item?.description,
            DisplayLink: item?.displayedLink,
            link: item?.link,
          };
        });
      case 'images':
        return data?.map((item, idx) => {
          return {
            id: idx + 1,
            title: item?.title,
            subTitle: item?.description,
            DisplayLink: item?.link,
            image: item?.image,
            link: item?.link,
            blockPosition: item?.blockPosition,
          };
        });
      case 'local_results':
        return data?.map((item, idx) => {
          return {
            id: idx + 1,
            title: item?.title,
            subTitle: item?.description,
            DisplayLink: item?.link,
            link: item?.link,
          };
        });
      case 'shopping':
        return data?.map((item, idx) => {
          return {
            id: idx + 1,
            title: item?.title,
            subTitle: item?.merchant,
            DisplayLink: item?.link,
            link: item?.link,
          };
        });
      default:
        return [];
    }
  };

  const getColors = val => {
    switch (val) {
      case 0:
        return '#7F4EAD';
      case 1:
        return '#F1AA3E';
      case 2:
        return '#34AEF3';
      case 3:
        return '#2D6CCA';
      case 4:
        return '#FF8536';
      case 5:
        return '#BFE15E';
      case 6:
        return '#4EBBAB';
      case 7:
        return '#F58069';
      case 8:
        return '#B61945';
      case 9:
        return '#617C14';
      default:
        return '#474747';
    }
  };

  const getSitesList = () => {
    const sitesArr = [];
    const sitesColorList = [];
    if (chartData?.length) {
      for (let index = 0; index < chartData.length; index++) {
        const element = chartData[index];
        for (let index = 0; index < element?.rankings?.length; index++) {
          const ranking = element?.rankings[index];
          const findSite = sitesArr?.findIndex(z => z == ranking?.site) !== -1;
          if (!findSite) {
            sitesArr.push(ranking?.site);
            sitesColorList.push({
              url: ranking?.site,
              color: getColors(index),
              checked: checkedList?.find(x => x?.url == ranking?.site)?.checked,
            });
          }
        }
      }
    }
    return sitesColorList;
  };

  useEffect(() => {
    if (chartData?.length) {
      setCheckedList(getSitesList()?.map(item => {
        return {
          ...item,
          checked: true,
        };
      }));
    }
  }, [chartData?.length]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const columns: ColumnsType = [
    // {
    //   title: '',
    //   key: 'position',
    //   dataIndex: 'position',
    //   width: 45,
    //   render: (_, data: any) => {
    //     const sitesList = checkedList?.map(z => z?.url);
    //     const sitesColors = checkedList;
    //     const site = sitesColors?.find(item => data?.data?.link == item?.url);
    //     return <div>
    //       {sitesList?.includes(data?.data?.link) ? <CheckBoxStyled color={site?.checked ? site?.color : '#F2F2F5'}>
    //         <Checkbox checked={site?.checked} onChange={e => {
    //           const getList = [...checkedList];
    //           const siteIndex = getList?.findIndex(x => x?.url == data?.data?.link);
    //           if (siteIndex != -1) {
    //             getList[siteIndex].checked = e.target?.checked;
    //             setCheckedList(getList);
    //           }
    //         }}/>
    //       </CheckBoxStyled> : ''}
    //     </div>;
    //   },
    // },
    {
      title: <span style={{marginLeft: '-8px'}}>POS</span>,
      key: 'position',
      dataIndex: 'position',
      width: 50,
      align: 'left',
      fixed: screenWidth >= 920 ? 'left' as 'left' : false,
      render: (_, data: any) => {
        return <div>{data?.data?.position ?? ''}</div>;
      },
    },
    {
      title: () => <span>PAGE / URL</span>,
      key: 'columnName',
      dataIndex: 'columnName',
      fixed: screenWidth >= 920 ? 'left' as 'left' : false,
      width: '90%',
      render: (_, data: any) => {
        return <div>
          {data?.type == 'organic_result' ? <div>
            <UrlDropdown url={data?.data?.link} text={data?.data?.title} countryCode={countryCode}/>
            <Link href={data?.data?.link} target='_blank' rel='noopener noreferrer'><LinkWrapper>{data?.data?.link}</LinkWrapper></Link>
          </div> : <div style={{marginBottom: '4px'}}>
            <CollapseStyled ghost expandIcon={({isActive}) => isActive ? <FontAwesomeIcon onClick={() => {}} icon={faCaretDown}/> :
              <FontAwesomeIcon onClick={() => {}} icon={faCaretRight}/>}>
              <Collapse.Panel key={`collapse_key_${data?.type}`} header={<div style={{fontWeight: 600}}>{data?.columnName}</div>}>
                <div style={{maxWidth: '500px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'break-spaces'}}>
                  {data?.type == 'images' || data?.type == 'knowledge_graph' ?
                    <div style={{display: 'flex', gap: '16px'}}>
                      { getArrangedData(data?.type, data?.data)?.map((item, index) => {
                        return <div key={`dynamic_results_${index}`}>
                          <div>
                            <div>
                              <NextImg style={{width: '46px', height: '46px', borderRadius: '8px', objectFit: 'cover'}} src={ data?.type == 'knowledge_graph' ? item?.link ? item?.link : '/img/icon/broken-image.svg' : item?.image ? item?.image : '/img/icon/broken-image.svg'}/>
                            </div>
                            <ImageLink href={item?.link} target='_blank' rel='noopener noreferrer'>{getDomain(item?.link)}</ImageLink>
                          </div>
                        </div>;
                      })} </div> :
                    getArrangedData(data?.type, data?.data)?.map((item, index) => {
                      return <div key={`dynamic_results_${index}`}>
                        {typeof item == 'string' ? <div style={{paddingLeft: '18px'}}>{item}</div> :
                          <ul style={{display: 'flex', paddingLeft: '32px'}}>
                            <li>
                              <div style={{fontWeight: 500}}>{item?.title || ''}</div>
                              <div>{item?.subTitle || ''}</div>
                              {item?.link ? <Link href={item?.link} target='_blank' rel='noopener noreferrer'>
                                {item?.DisplayLink}
                              </Link> : ''}
                            </li>
                          </ul>}
                      </div>;
                    })}</div>
              </Collapse.Panel>
            </CollapseStyled>
          </div>}
        </div>;
      },
    },
    {
      title: <Tooltip title={<TooltipDescriptionWrapper>
        {`The strength of your target's backlink profile compared to the other websites in our database on a 100-point logarithmic scale
`}      </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}> <div>
          <span>domain</span><br/>
          <span>rating</span>
        </div></Tooltip>,
      key: 'dr',
      dataIndex: 'dr',
      align: 'left',
      width: 80,
      sorter: (a: any, b: any) => a?.data?.dr - b?.data?.dr,
      render: (_, data: any) => {
        return <>
          {data?.type == 'organic_result' ?
            <DrContainer background={`${getProgressColor(data?.data?.dr || 0, 25, 50, 75)}12`}>
              <span style={{color: getProgressColor(data?.data?.dr || 0, 25, 50, 75)}}>•</span>&nbsp;{data?.data?.dr}
            </DrContainer> : ''}
        </>;
      },
    },
    {
      title: <div>
        <span>domain</span><br/>
        <span>authority</span>
      </div>,
      key: 'authorityScore',
      dataIndex: 'authorityScore',
      align: 'left',
      width: 100,
      sorter: (a: any, b: any) => a?.data?.authorityScore - b?.data?.authorityScore,
      render: (_, data: any) => {
        return <>
          {data?.type == 'organic_result' ?
            <DrContainer background={`${getProgressColor(data?.data?.authorityScore || 0, 25, 50, 75)}12`}>
              <span style={{color: getProgressColor(data?.data?.authorityScore || 0, 25, 50, 75)}}>•</span>&nbsp;{data?.data?.authorityScore || '-'}
            </DrContainer> : ''}
        </>;
      },
    },
    {
      title: <div>
        <span>backlinks</span>
      </div>,
      key: 'backlinksCount',
      dataIndex: 'backlinksCount',
      align: 'left',
      width: 100,
      sorter: (a: any, b: any) => a?.data?.backlinksCount - b?.data?.backlinksCount,
      render: (_, data: any) => {
        return <>
          &nbsp;{data?.type == 'organic_result' ? data?.data?.backlinksCount ? formatLargeNumber(data?.data?.backlinksCount, 1)?.toString()?.replace('.0', '') : '-' : ''}
        </>;
      },
    },
    {
      title: <Tooltip title={<TooltipDescriptionWrapper>
        {`Referring domains are websites from which the page has one or more backlinks.`}
      </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}>  <div>
          <span>page ref.</span><br/>
          <span>domains</span>
        </div></Tooltip>,
      key: 'domains',
      dataIndex: 'domains',
      align: 'left',
      width: 100,
      sorter: (a: any, b: any) => a?.data?.domainsCount - b?.data?.domainsCount,

      render: (_, data: any) => {
        return <div>
          &nbsp;{data?.type == 'organic_result' ? data?.data?.domainsCount ? formatLargeNumber(data?.data?.domainsCount, 1)?.toString()?.replace('.0', '') : <span> - </span> : ''}
        </div>;
      },
    },
    // {
    //   title: <span>keywords</span>,
    //   key: 'keywordsCount',
    //   dataIndex: 'keywordsCount',
    //   align: 'left',
    //   width: 100,
    //   sorter: (a: any, b: any) => a?.data?.keywordsCount - b?.data?.keywordsCount,

    //   render: (_, data: any) => {
    //     return <div>
    //       &nbsp;&nbsp;{data?.type == 'organic_result' ? data?.data?.keywordsCount ? formatLargeNumber(data?.data?.keywordsCount, 1)?.toString()?.replace('.0', '') : '-' : ''}
    //     </div>;
    //   },
    // },
    {
      title: <Tooltip title={<TooltipDescriptionWrapper>
        {`We estimate the monthly organic search traffic a result gets from all the keywords it ranks for, based on the 12-month average of searches for those ranking keywords.`}      </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}>  <div>
          <span>organic</span><br/>
          <span>traffic</span>
        </div></Tooltip>,
      key: 'ot',
      dataIndex: 'ot',
      align: 'left',
      width: 90,
      sorter: (a: any, b: any) => a?.data?.traffic - b?.data?.traffic,

      render: (_, data: any) => {
        return <div>
          &nbsp;{data?.type == 'organic_result' ? data?.data?.traffic ? formatLargeNumber(data?.data?.traffic, 1)?.toString()?.replace('.0', '') : '-' : ''}
        </div>;
      },
    },
    // {
    //   title: <Tooltip title={<TooltipDescriptionWrapper>
    //     {`We estimate the monthly organic search traffic a result gets from all the keywords it ranks for, based on the 12-month average of searches for those ranking keywords.`}      </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}>  <div>
    //       <span>total domain</span><br/>
    //       <span>traffic</span>
    //     </div></Tooltip>,
    //   key: 'traffic',
    //   dataIndex: 'traffic',
    //   align: 'left',
    //   width: 100,
    //   sorter: (a: any, b: any) => a?.data?.ot - b?.data?.ot,

    //   render: (_, data: any) => {
    //     return <div>
    //       &nbsp;{data?.type == 'organic_result' ? data?.data?.ot ? formatLargeNumber(data?.data?.ot, 1)?.toString()?.replace('.0', '') : '-' : ''}
    //     </div>;
    //   },
    // },
    // {
    //   title: <span>keywords</span>,
    //   key: 'sv',
    //   dataIndex: 'sv',
    //   align: 'right',
    //   width: 80,
    //   render: (_, data: any) => {
    //     return <div>
    //       {data?.data?.dr}
    //     </div>;
    //   },
    // },
    // {
    //   title: <div>
    //     <span>page</span><br/>
    //     <span>backlinks</span>
    //   </div>,
    //   key: 'cpc',
    //   dataIndex: 'cpc',
    //   align: 'right',
    //   width: 100,
    //   render: (_, data: any) => {
    //     return <div>
    //       {data?.data?.dr}
    //     </div>;
    //   },
    // },
  ];

  const tooltipFormatter = function(series: any) {
    const element = (
      <TooltipContainer>
        <span style={{fontWeight: 'bold'}}>
          {moment(series[0].axisValue).format('MMM DD, YYYY')}
        </span>
        <StyledTable>
          <tr>
            <th>URL</th>
            <th>POSITION</th>
          </tr>
          {series?.filter(items=> items?.data)?.sort((a, b) => a?.data - b?.data)?.map((item, index: number) => {
            return (
              <tr key={index}>
                <td>
                  <span>
                    <Badge color={item.color} dot size='small' />
                    {truncate(item.seriesName, 65)}
                  </span>
                </td>
                <td>{numeral(item.data).format('0.[0][a]').toUpperCase()}</td>
              </tr>
            );
          })}
        </StyledTable>
      </TooltipContainer>
    );
    return renderToString(element);
  };

  const makeSeries = (): EChartOption.Series[] => {
    if (chartData?.length && !loadingOrganicPaidHistoryDetails) {
      const sitesList = checkedList;
      const dataArr = sitesList?.slice(0, 10)?.map(item => {
        const siteData = chartData?.map(z => z?.rankings?.find(x => x?.site == item?.url)?.rank);
        return {
          name: item?.url,
          type: 'line',
          symbol: 'none',
          itemStyle: {
            color: item?.color,
          },
          lineStyle: {
            color: item?.color,
          },
          areaStyle: {
            color: 'transparent',
          },
          data: item?.checked ? siteData : [],
        };
      });
      return dataArr;
    } else {
      return [{
        name: 'loading',
        type: 'line',
        symbol: 'none',
        itemStyle: {
          color: '#A3A4A4',
        },
        lineStyle: {
          color: '#A3A4A4',
        },
        areaStyle: {
          color: new graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: 'rgb(163, 164, 164)',
          }, {
            offset: 0.9,
            color: '#fff',
          }]),
        },
        data: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      }];
    }
  };
  // const searchVolum = getKeywordDetailList?.keywords?.find(item => item?.keyword == keSelectedKeyword)?.sv;
  const getChartInterval = ()=>{
    if (chartData?.length > 500) return 35;
    else if (chartData?.length > 200) return 9;
    else if (chartData?.length > 100) return 7;
    else if (chartData?.length > 50) return 4;
    else if (chartData?.length > 35) return 2;
    else return 0;
  };
  const handelLoadMore = ()=> {
    if (isPublicKeywordResearcherV2()) {
      setAuthModal(true, false);
    } else {
      setLoadAllRecord(true);
    }
  };

  const exportSerpClickHandler = () => {
    keywordSerp && exportSerpTable(keywordSerp[0], keywordSerp[1]?.replaceAll('+', ' '));
  };
  const chartTabs = ['3m', '6m', '1y', 'All time'];
  const path =
    'path://M6.75 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM216 232V334.1l31-31c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0l-72-72c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l31 31V232c0-13.3 10.7-24 24-24s24 10.7 24 24z';
  const getData = () => {
    return getSerpOverviewDetails?.results?.filter(itm => {
      if (itm?.type === 'knowledge_graph') {
        const images = (itm.data as any)?.images;
        return Array.isArray(images) && images.length > 0;
      }
      if (itm?.type === 'people_also_ask') {
        const questionsAnswers = (itm.data as any[])?.length;
        return questionsAnswers > 0;
      }
      return true;
    });
  };
  return (
    <MainContainer>
      <CardsContainer>
        {/* <Box>
          <BoxTitle>{'Keyword Difficulty'}&nbsp;&nbsp;<Tooltip title={<TooltipDescriptionWrapper>
            An estimation of the competitive landscape of this keyword. Higher Keyword Difficulty means more competition.
          </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}> <FontAwesomeIcon color='#DADADA' icon={faCircleInfo}/> </Tooltip> </BoxTitle>
          <BoxValue>{loadingOrganicPaidHistoryDetails ? <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} /> : cardsData?.difficulty ?? '-'}</BoxValue>
          {loadingOrganicPaidHistoryDetails ? <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'} /> :
            <BoxDescription>Total volume: <span style={{fontWeight: 500}}>{searchVolum ? formatNumber(searchVolum) : '-'}</span></BoxDescription>}
        </Box> */}
        <Box>
          <BoxTitle>{'Homepages'} &nbsp;&nbsp;<Tooltip title={<TooltipDescriptionWrapper>
            The number of homepages ranking for this keyword.
          </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}> <FontAwesomeIcon color='#DADADA' icon={faCircleInfo}/> </Tooltip></BoxTitle>
          {loadingOrganicPaidHistoryDetails || cardsData?.homepages || cardsData?.govEduDomains ? <>
            <BoxValue>{loadingOrganicPaidHistoryDetails ? <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} /> : cardsData?.homepages ?? '-'}</BoxValue>
            {loadingOrganicPaidHistoryDetails ? <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'} /> :
              <BoxDescription>.gov, .edu domains: <span style={{fontWeight: 500}}>{cardsData?.govEduDomains}</span></BoxDescription>}</> :
            <EmptyStateKeDetail search={true} keywordCompetition={true} description = {'Data not found.'}/>

          }
        </Box>
        <Box>
          <BoxTitle>Monthly Clicks  &nbsp;&nbsp;<Tooltip title={<TooltipDescriptionWrapper>
            {`The expected number of clicks for the top organic results & The value of all the clicks a domain gets from being in the top spot.`}
          </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}> <FontAwesomeIcon color='#DADADA' icon={faCircleInfo}/> </Tooltip> </BoxTitle>

          {loadingOrganicPaidHistoryDetails ? <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} /> :
            cardsData?.monthlyClicks || cardsData?.monthlyCost ?<>

              <div style={{display: 'flex', alignItems: 'baseline', marginLeft: '-4px'}}>
                <BoxValue>{cardsData?.monthlyClicks ? formatNumber(cardsData?.monthlyClicks) : 0}</BoxValue>
            &nbsp;<BoxDescription>worth</BoxDescription>&nbsp;
                <BoxValue>${cardsData?.monthlyCost ? formatNumber(cardsData?.monthlyCost) : 0}</BoxValue>
              </div></>:
              <EmptyStateKeDetail search={true} keywordCompetition={true} description = {'Data not found.'}/>

          }
          {loadingOrganicPaidHistoryDetails ? <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'} /> :
            <BoxDescription>{cardsData?.monthlyClicks || cardsData?.monthlyCost ? 'For Position 1' : ''}</BoxDescription>}
        </Box>
        <Box>
          <BoxTitle>Keywords in title &nbsp;&nbsp;<Tooltip title={<TooltipDescriptionWrapper>
            {`This measures the number of results in the SERP where the exact keyword is in the page's title.`}
          </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}> <FontAwesomeIcon color='#DADADA' icon={faCircleInfo}/> </Tooltip></BoxTitle>
          {loadingOrganicPaidHistoryDetails || cardsData?.keywordsInUrl || cardsData?.keywordsInUrl ? <>
            <BoxValue>{loadingOrganicPaidHistoryDetails ? <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} /> : cardsData?.keywordsInTitle ?? '-'}</BoxValue>
            {loadingOrganicPaidHistoryDetails ? <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'} /> :
              <BoxDescription>Keywords in URL: <span style={{fontWeight: 500}}>{formatNumber(cardsData?.keywordsInUrl)}</span></BoxDescription>}</> :
            <EmptyStateKeDetail search={true} keywordCompetition={true} description = {'Data not found.'}/>

          }

        </Box>
        <Box>
          <BoxTitle>Domain Diversity&nbsp;&nbsp;<Tooltip title={<TooltipDescriptionWrapper>
            {`If one domain dominates the top 100 results for this keyword, the diversity is low. High domain diversity includes a variety of results. Either extreme should raise a flag.`}
          </TooltipDescriptionWrapper>} placement={'bottomLeft'} color='#fff' overlayInnerStyle={{borderRadius: '6px', maxHeight: '200px', width: '300px'}}> <FontAwesomeIcon color='#DADADA' icon={faCircleInfo}/> </Tooltip></BoxTitle>
          {loadingOrganicPaidHistoryDetails || cardsData?.diversity ? <>
            <BoxValue>{loadingOrganicPaidHistoryDetails ? <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'60%'} /> : (formatNumber(cardsData?.diversity) ?? '-')}</BoxValue>
            {loadingOrganicPaidHistoryDetails ? <SkeletonHorizontalLoaderGray align='left' lightLoader skeletonMarginLeft={'0px'} height={'25px'} skeletonHeight={8} width={'80%'} /> :
              <BoxDescription>Social: <SocialImgContainer>
                <NextImg style={{opacity: cardsData?.wikipedia ? '100%' : '20%'}} src={'/icons/wikipedia.svg'}/>
                <NextImg style={{opacity: cardsData?.facebook ? '100%' : '20%'}} src={'/icons/facebookBlueIcon.svg'}/>
                <NextImg style={{opacity: cardsData?.twitter ? '100%' : '20%'}} src={'/icons/twitter.svg'}/>
                <NextImg style={{opacity: cardsData?.youtube ? '100%' : '20%'}} src={'/icons/youtube.svg'}/>
                <NextImg style={{opacity: cardsData?.pinterest ? '100%' : '20%'}} src={'/icons/pinterest.svg'}/>
                <NextImg style={{opacity: cardsData?.tumblr ? '100%' : '20%'}} src={'/icons/tumblr.svg'}/>
                <NextImg style={{opacity: cardsData?.linkedIn ? '100%' : '20%'}} src={'/icons/linkedinBlueIcon.svg'}/>
              </SocialImgContainer></BoxDescription>}</> :
            <EmptyStateKeDetail search={true} keywordCompetition={true} description = {'Data not found.'}/>
          }
        </Box>
      </CardsContainer>
      {loadingOrganicPaidHistoryDetails ? <CompetitionChart>
        <BoxTitle style={{marginBottom: '10px'}}>Historical Organic Search Results</BoxTitle>
        <div style={{padding: '50px'}}>
          <SkeletonRingLoader />
        </div>
      </CompetitionChart>:
        (chartData?.length ? <CompetitionChart>
          <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'absolute', right: 110, zIndex: 1}}>

            <CustomTabContainer>
              {!isPublicKeywordResearcherV2 && chartTabs.map(tab => {
                return <CustomTab key={tab} selected={selectedDuration == tab} onClick={() => setSelectedDuration(tab)}>{tab}</CustomTab>;
              })}
            </CustomTabContainer>
          </div>
          <ChartContainer>
            {(isPublicKeywordResearcherV2() && isWhiteLabelDomain) ? '' : isPublicKeywordResearcherV2() && <ChartOverlayBanner bannerHeight='65%' bannerWidth='75%' left='0px'/>}
            <BoxTitle style={{marginBottom: '10px'}}>Historical Organic Search Results</BoxTitle>
            <ReactEcharts
              style={{width: '100%', height: '100%'}}
              option = {
              {
                tooltip: {
                  trigger: 'axis',
                  show: chartData?.length ? true: false,
                  formatter: tooltipFormatter,
                  confine: true,
                },
                toolbox: {
                  showTitle: false,
                  show: true,
                  itemStyle: {
                    color: '#121212',
                  },
                  feature: {
                    saveAsImage: {
                      show: true,
                      icon: path,
                      title: 'Export',
                    },
                  },
                },
                legend: {
                  show: chartData?.length ? true : false,
                  icon: 'circle',
                  left: 0,
                  padding: [0, 40, 0, 0],
                  itemWidth: 9,
                  itemHeight: 9,
                  formatter: function(name) {
                    return `${truncate(removeProtocolAndPrefix(name), 22)}`;
                  },
                  type: screenWidth >= 730 ? 'plain' : 'scroll',
                },
                grid: {
                  left: 10,
                  right: 30,
                  bottom: 40,
                  top: 50,
                },
                xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  axisLabel: {
                    hideOverlap: true,
                    align: 'left',
                    interval: screenWidth <= 768 ? 3 : getChartInterval(),
                    formatter: value => {
                      if (selectedDuration == 'All time') {
                        return `${moment(value)?.format('MMM')}`;
                      } else {
                        return `${moment(value)?.format('D MMM YYYY')}`;
                      }
                    },
                  },
                  data: chartData?.length ? chartData?.map(item => item?.date) : ['01-07-2020', '01-08-2020', '01-09-2020', '01-010-2020', '01-06-2020', '01-11-2020', '01-12-2020', '01-01-2021', '01-02-2021', '01-03-2021'],
                },
                yAxis: {
                  type: 'value',
                  position: 'right',
                  inverse: chartData?.length ? true : false,
                },
                series: makeSeries(),
              } as EChartOption
              }
            />
          </ChartContainer>
        </CompetitionChart> : '')}
      {/* <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '250px'}}>
              <EmptyStateKeDetail imgText={'/icons/empty-z-line.svg'} icon={true} text={'Historical SERP data is unavailable or missing.'} description = {'Data not found.'}/>
            </div> */}
      <SerpTableContainer>
        {loadingSerpOverviewDetails || getSerpOverviewDetails?.results ?
          <>
            <TableTitle style={{margin: '13px 8px', fontWeight: 500, fontSize: '15px'}}>
              <TableTitleContainer>
              SERP Overview for “{router?.query?.keyword?.length ? router?.query?.keyword[1]?.replaceAll('+', ' ') : 'keyword'}”
                {/* hide button from the gsc drawer page if query params have no keyword array  */}
                {isPublicKeywordResearcherV2() && isWhiteLabelDomain ? ' ' : keywordSerp?.length >= 1 ? <Button
                  buttonType={'primary'}
                  size={'sm'}
                  onClick={() => exportSerpClickHandler()}
                  loading={exportingSerpOverview}
                  style={{whiteSpace: 'nowrap'}}
                >Export SERP</Button> : <></> }
              </TableTitleContainer>
            </TableTitle>
            <TableContainer>
              <TableStyled
                dataSource={loadAllRecord ? getData() : getData()?.slice(0, 10) || []}
                columns={columns}
                pagination={false}
                loading={loadingSerpOverviewDetails}
                loadingRows={10}
                scroll={{y: 600, x: 1120}}
                rowClassName={(_, index) => isPublicKeywordResearcherV2() && index > 9 ? 'bluredRowStyle' : ''}
              />
              {isPublicKeywordResearcherV2() && isWhiteLabelDomain ? ' ' : !loadAllRecord && getSerpOverviewDetails?.results?.length ? <div onClick={() => handelLoadMore()} style={{color: '#2D6CCA', cursor: 'pointer', textAlign: 'center'}}>Load more</div> : ''}
            </TableContainer> </>:
          <EmptyStateKeDetail imgText={'/img/backgroundfasearch.svg'} icon={true} text={'SERP data is unavailable or missing.'} description = {'Data not found.'}/>
        }
      </SerpTableContainer>
    </MainContainer>
  );
});
const TooltipContainer = styled.div`
  width: 550px;
  @media screen and (max-width: 850px) {
    width: auto !important;
    min-width: 200px;
    max-width: 550px;
  }
`;

const TableTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
`;
const ChartContainer = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`;
const ImageLink = styled.a`
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  white-space: nowrap;
  display: block;
  margin-top: 5px;
  color: #2D6CCA;
  max-width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const MainContainer = styled.div`
  background: transparent;
  margin-top: 15px;
`;

const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;
`;
const LinkWrapper = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: #075A1F;
`;
const Box = styled.div`
  min-width: 220px;
  width: 23.64%;
  height: 120px;
  background: #F9F9FB;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  padding: 22px 20px 20px 25px;
  @media screen and (max-width: 830px) {
    flex-grow: 1;
  }
  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const StyledTable = styled.table`
  width: 100%;
  tr {
    display: flex;
    justify-content: space-between;
    border: 1px solid #dcdcde;
    border-collapse: collapse;
  }
  tr:first-child {
    background-color: #ececef;
  }
`;

const SocialImgContainer = styled.span`
  display: flex;
  align-items: center;

  img {
    width: 20px;
    height: 18px;
  }
`;

const BoxTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  text-transform: uppercase;
  color: #121212;
`;

const BoxValue = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #121212;
  margin-top: 3px;
  min-height: 29px;
`;

const BoxDescription = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #4E5156;
  margin-top: 5px;
  display: flex;
  align-items: center;
`;

const CompetitionChart = styled.div`
  height: 312px;
  margin-top: 16px;
  background: #FFFFFF;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  padding: 25px;
`;


const TableTitle = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #121212;
`;

const SerpTableContainer = styled.div`
  background: #FFFFFF;
  border: 1px solid #E8E8E8;
  box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.02);
  border-radius: 8px;
  padding: 10px;
  margin-top: 15px;
  margin-bottom: 30px;
`;

const TableContainer = styled.div`
 padding-bottom: 0 !important;

 .bluredRowStyle {
  filter: blur(10px);
  pointer-events: none;
 }

table tr th {
  background-color: #fff;
}

.ant-table-body {
  &::-webkit-scrollbar {
      height: 5px;
      width: 5px;
    }
  
    &::-webkit-scrollbar-thumb {
      background: rgba(138,138,138,0.32);
    }
  
    &::-webkit-scrollbar-track {
      background: rgba(138,138,138,0.12);
    }
}

.ant-table-content {
  border-radius: 0 !important;
}

.ant-table-column-sorters-with-tooltip:not(:first-child) {
  text-align: center;
}

table {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;

  th::before {
    width: 0 !important;
  }

  .ant-table-column-sorter {
    display: flex;
    padding-left: 3px !important;
  }

  .ant-table-column-sorters {
    display: inline-flex !important;
    padding: 5px !important;
  }

  tr td {
    &:first-child {
      padding-bottom: 0 !important;
      padding-top: 0 !important;
    }
  }

  .ant-table-tbody {
    .ant-table-cell {
    vertical-align: top;
    padding-top: 10px !important;
    padding-bottom: 5px !important;
  }
    tr:nth-child(even) {
      td {
        background: #fff !important;
        border-bottom: 1px solid #f4f4f4 !important;
        box-shadow: none;
        font-weight: 400;
        white-space: nowrap;
      }

      &:hover {
        td {
          background: #eef4fe !important;
        }

        button {
          background: #eef4fe !important;
          border: 0 !important;
          color: #2d6cca;
          font-weight: 500;
        }
      }
    }

    tr:nth-child(odd) {
      td {
        background: #fff;
        border-bottom: 1px solid #f4f4f4 !important;
        box-shadow: none;
        font-weight: 400;
        white-space: nowrap;
      }

      &:hover {
        td {
          background: #eef4fe !important;
        }

        button {
          background: #eef4fe !important;
          border: 0 !important;
          color: #2d6cca;
          font-weight: 500;
        }
      }
    }
  }

  .ant-table-thead {
    background: #f7f7f7 !important;

    th {
      font-weight: 700;
      font-size: 12px;
      line-height: 14px;
      color: #121212;
      text-transform: uppercase;
    }

    .ant-table-cell-fix-left {
      text-align: left !important;

      &:first-child {
        border-bottom-left-radius: 8px !important;
        border-top-left-radius: 8px !important;
      }
    }

    th:first-child {
      border-bottom-left-radius: 8px !important;
      border-top-left-radius: 8px !important;
    }

    th:last-child {
      border-bottom-right-radius: 8px !important;
      border-top-right-radius: 8px !important;
      padding-left: 25px !important;
    }
  }

  .ant-table-cell-fix-left-last {
    text-align: left !important;
  }

  tr:first-child td {
    background: #fff !important;
  }

  tr:nth-child(even) td {
    background: #f9f9fb !important;
  }

  tr:nth-child(odd) td {
    background-color: #fff !important;
  }

  tr th {
    height: 50px !important;
    line-height: 22px;
    white-space: nowrap;
  }

  .ant-column-sorters {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  tr td {
    padding-bottom: 15px;
    padding-top: 15px;
    text-align: center;
  }

  tr th:first-child,
  tr td:first-child {
    padding-left: 25px !important;
    padding-right: 25px !important;
  }

  tr th:last-child,
  tr td:last-child {
    padding-left: 25px !important;
    padding-right: 25px !important;
    text-align: center;
  }
}
`;

const CollapseStyled = styled(Collapse)`
  .ant-collapse-header {
    padding: 0 !important;
  }
  .ant-collapse-content-box {
    padding-left: 0 !important;
    padding-bottom: 0 !important;
  }
`;

const Link = styled.a`
  font-weight: 400;
  font-size: 12px !important;
  line-height: 15px;
  color: #2D6CCA !important;
  text-decoration: none;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
  max-width: 500px;
`;

const DrContainer = styled.div<{background: string}>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 7px 12px 8px;
  position: absolute;
  height: 32px;
  background: ${p => p.background ? p.background : `rgba(244, 67, 67, 0.07)`};
  border-radius: 6px;
`;

const CustomTabContainer = styled.div`
  display: flex;
  align-items: center;
  div:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  div:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }
`;

const CustomTab = styled.div<{selected?: boolean}>`
  height: 28px;
  background: ${p => p.selected ? 'rgba(127, 78, 173, 0.15)' : '#F2F2F5'};
  border: 1px solid ${p => p.selected ? 'rgba(127, 78, 173, 0.3)' : '#E2E2E2'};
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0 8px 0 6px;
`;

// const CheckBoxStyled = styled.div<{color: string}>`
//   .ant-checkbox-inner {
//     background-color: ${p => p.color} !important;
//     border-color: ${p => p.color == '#F2F2F5' ? `#D2D2D2` : p?.color} !important;
//     border-radius: 3px !important;
//   }
// `;
const TooltipDescriptionWrapper = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #121212;
  padding: 5px;
`;

// SERP's position history chart is temporarily hidden and will be implemented soon
